import React from 'react';
import './linktree.css';
import ProximaText from './linktreeText';

const linktree = ({ onClose }) => {
    return (
        <div className="linktree-popup-overlay">
            <div className="linktree-popup-container">
                <button className="linktree-close-button" onClick={onClose}>{'\u00D7'}</button>
                <div className="linktree-popup-content">
                    <ProximaText />
                </div>
            </div>
        </div>
    );
};

export default linktree;